module.exports = __webpack_public_path__ + "img/solution-modoler.b592567d.png";